










import { Vue, Component } from 'vue-property-decorator';
import ConsultaInstalacionesBase from './ConsultaInstalacionesBase.vue';

@Component({ components: { ConsultaInstalacionesBase } })
export default class ConsultaInstalacionesPantalla extends Vue {}
